import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import chevronback from "../../assets/img/chevronback.svg";
import chevronforward from "../../assets/img/chevronforward.svg";

const TabModelo = ({ item, selectedColor, selectedTransmision, setSelectedTransmision, setSelectedColor }) => {
  console.log(selectedColor, "Selected color");
  console.log(item, "Selected item");
  console.log(item?.types.filter((t) => t.transmision === selectedTransmision)[0]);

  let coloresTotales = item.types
    .filter((t) => t.transmision === selectedTransmision)[0]
    .colores?.map((colores) => colores);

  // Function to find the current index of the selected color
  function findCurrentIndex(color) {
    return coloresTotales.findIndex((item) => item.color === color);
  }

  // Function to move to the next color
  function moveToNextColor(color) {
    let currentIndex = findCurrentIndex(color);
    let nextIndex = (currentIndex + 1) % coloresTotales.length;
    selectedColor = coloresTotales[nextIndex].color;
    setSelectedColor(coloresTotales[nextIndex]);
    console.log("Next color selected:", selectedColor);
  }

  // Function to move to the previous color
  function moveToPreviousColor(color) {
    let currentIndex = findCurrentIndex(color);
    let prevIndex = (currentIndex - 1 + coloresTotales.length) % coloresTotales.length;
    selectedColor = coloresTotales[prevIndex].color;
    setSelectedColor(coloresTotales[prevIndex]);
    console.log("Previous color selected:", selectedColor);
  }

  console.log(item);

  return item ? (
    <Col className="text-center pb-5 card m-1">
      <Row>
        <Col md={11} xl={11} xxl={11} xs={12} className="mx-auto pt-md-4 pt-4">
          <div>
            <p className="text-start fw-bold ps-3" style={{ fontSize: "24px" }}>
              RAMPAGE {item.id}
            </p>
          </div>
        </Col>
      </Row>

      <div className="pb-3 d-flex justify-content-between flex-row">
        <div className="pt-5">
          <div className="pt-4">
            <img
              src={chevronback}
              onClick={() => moveToPreviousColor(selectedColor.color)}
              style={{
                width: item.id === "LARAMIE" || item.id === "LARAMIE NIGHT EDITION" ? 47 : 160,
                cursor: "pointer",
              }}
            />
          </div>
        </div>

        <div>
          <img src={selectedColor?.file} alt={item?.modelo} className="img-fluid" />
        </div>
        <div className="pt-4">
          <div className="pt-5">
            <img
              src={chevronforward}
              onClick={() => moveToNextColor(selectedColor.color)}
              style={{
                width: item.id === "LARAMIE" || item.id === "LARAMIE NIGHT EDITION" ? 47 : 160,
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </div>

      <Row>
        <Col md={11} xl={11} xxl={11} xs={12} className="mx-auto pt-md-2 pt-2">
          <div>
            <p className="text-start fw-bold ps-3 mb-1">Colores disponibles en este versión</p>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={11} xl={11} xxl={11} xs={12} className="mx-auto pt-md-0 pt-0">
          <div className="pb-3 d-flex justify-content-start flex-row ps-2">
            {coloresTotales?.map((colores) => (
              <div
                className="divColor m-2 "
                style={{ backgroundColor: colores.color, cursor: "pointer" }}
                onClick={() => setSelectedColor(colores)}
              ></div>
            ))}
          </div>
        </Col>
      </Row>

      <div>
        <Row>
          <Col md={11} xl={11} xxl={11} xs={12} className="mx-auto pt-md-1 pt-4">
            <p className="text-start fw-bold ps-3">Sus principales características</p>
            <ul>
              {item.types
                .filter((t) => t.transmision === selectedTransmision)[0]
                .specs?.map((item) => (
                  <li className="text-start">{item}</li>
                ))}
            </ul>
          </Col>
        </Row>
      </div>
      <div className="pt-md-4 pt-2 pb-1 text-center flex-md-row flex-column d-flex">
        <a href={item.ficha} className="linkDefault d-block mx-auto" target="_blank" rel="noreferrer">
          <div className="d-flex justify-content-start flex-row align-content-center align-items-center pt-4">
            <div style={{ color: "#000" }}>Ver Ficha Técnica completa</div>
          </div>
        </a>

        <a
          href={"#form"}
          target={"_self"}
          rel="noreferrer"
          className="btn btn-blue-destacado  ps-4 pe-4 pt-3 pb-3 me-md-4 ms-5 me-5 text-center mt-md-0 mt-3"
          style={{ cursor: "pointer", textDecoration: "none", color: "#000", textAlign: "center" }}
        >
          Solicitar cotización
        </a>
      </div>
    </Col>
  ) : (
    <p>Cargando...</p>
  );
};

export default TabModelo;
